import { userService } from '../_services';
import { router } from '../_helpers';

/*
const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { items: user.basket }
    : { items: [] };
*/

export const fav = {
    namespaced: true,
    state: {
      items: [],
      all: {}
    },
    actions: {
      update({ dispatch, commit }, { fav }){

        var user = JSON.parse(localStorage.getItem('user'))
        user.fav = fav
        localStorage.setItem('user', JSON.stringify(user));
        
        userService.updateFav(fav)
          .then(
                fav => {
                    commit('updateRequest', { fav } );

                },
                error => {
                    commit('updateError', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
                    
                    
      }
    },
    mutations: {
      
        updateRequest(state){
            state.all = { loading: true };
        },
        updateSuccess(state, fav){
            state.all = fav ;
        },
        updateError(state, error ){
            state.all = { error };
        },
      
    }
}